import React from 'react';
import { QuestionComponentProps } from '../QuestionComponent.types';
import { CustomQuestion } from '../Question';
import Star from 'assets/livenicons/star_v2.svg';
import Trigger from 'assets/livenicons/trigger.svg';
import Puzzle from 'assets/livenicons/puzzle.svg';
import Challenge from 'assets/livenicons/challenge.svg';
import ProfileAvatarMen from 'assets/livenicons/liven_profile_negative_men.png';
import ProfileAvatarWomen from 'assets/livenicons/liven_profile_negative_women.png';
import PersonSummaryLevel from 'assets/livenicons/person_summary_level.svg';
import { StickyContainer } from 'components/stickycontainer/StickyContainer';
import Spacer from 'components/spacer/Spacer';
import { useAppDispatch, useAppSelector } from 'bootstrap/hooks';
import { appAnalytics } from 'analytics';
import { goToNextQuestion } from 'bootstrap/onboarding/actions';
import { SaveAnswer } from 'analytics/AllEvents';
import { useFeatures } from 'useFeatures';

import { Genders } from 'welcome/livenwelcome/LivenWelcome.hook';
import { LIVEN_ANSWERS_MAP } from 'utils/utils.constants';
import { QuestionIds } from 'onboarding/data/constants/QuestionIds';
import styles from './styles.module.scss';

type Props = QuestionComponentProps<CustomQuestion>;

export const LivenProfileSummary: React.FC<Props> = ({ question }: Props) => {
  const dispatch = useAppDispatch();
  const features = useFeatures();

  const { answers } = useAppSelector((state) => state.onboarding);

  const nextButtonHandler = () => {
    setTimeout(() => {
      appAnalytics.trackEvent(new SaveAnswer(question.id));
      dispatch(goToNextQuestion(features));
    }, 250);
  };

  return (
    <div className={styles.container}>
      <h3 className={styles.title}>Summary of your Well-being Profile</h3>
      <div className={styles.sumaryResultsCard}>
        <div className={styles.summaryResultCardHeader}>
          <p>ADHD signs level</p>
          <div className={styles.label}>Medium</div>
        </div>
        <img
          src={
            answers[QuestionIds.Welcome] === Genders.Male
              ? ProfileAvatarMen
              : ProfileAvatarWomen
          }
          alt=""
        />
        <div className={styles.alertMessageWarning}>
          <div className={styles.image}>
            <img src={PersonSummaryLevel} alt="" />
          </div>

          <div className={styles.contentWrapper}>
            <p className={styles.header}>MEDIUM level</p>
            <p className={styles.description}>
              This means you may occasionally feel worried, experience some
              pressure, notice a slight decrease in energy, and have minor
              disruptions to your sleep patterns.
            </p>
          </div>
        </div>

        <div className={styles.summaryResultCardProgress}>
          <div className={styles.slider}>
            <div className={styles.line}></div>
            <div className={styles.line}></div>
            <div className={styles.line}></div>
            <div className={styles.line}></div>
            <div className={styles.circle} style={{ left: '70%' }}>
              <div className={styles.tool}>
                <p>Your level</p>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.note}>
          This self assesment is for informational purposes only, where you can
          assess what type of ADHD your signs may be attributed to based on your
          respocnes in the quiz
        </div>
      </div>

      <div className={styles.typeList}>
        <div className={styles.typeListItem}>
          <div className={styles.image}>
            <img src={Puzzle} alt="" />
          </div>
          <div className={styles.listItemContentWrapper}>
            <p className={styles.header}>ADHD Type</p>
            <p className={styles.description}>Impulsive</p>
          </div>
        </div>

        <div className={styles.typeListItem}>
          <div className={styles.image}>
            <img src={Challenge} alt="" />
          </div>
          <div className={styles.listItemContentWrapper}>
            <p className={styles.header}>Challenging period</p>
            <p className={styles.description}>
              {LIVEN_ANSWERS_MAP[answers[QuestionIds.WellbeingQ10] as string]}
            </p>
          </div>
        </div>

        <div className={styles.typeListItem}>
          <div className={styles.image}>
            <img src={Trigger} alt="" />
          </div>
          <div className={styles.listItemContentWrapper}>
            <p className={styles.header}>Trigger</p>
            <p className={styles.description}>
              {
                LIVEN_ANSWERS_MAP[
                  answers[QuestionIds.WellbeingQ30]?.[0] as string
                ]
              }
            </p>
          </div>
        </div>

        <div className={styles.typeListItem}>
          <div className={styles.image}>
            <img src={Star} alt="" />
          </div>
          <div className={styles.listItemContentWrapper}>
            <p className={styles.header}>Self-confidence level</p>
            <p className={styles.description}>
              {LIVEN_ANSWERS_MAP[answers[QuestionIds.WellbeingQ14] as string]}
            </p>
          </div>
        </div>
      </div>

      <Spacer />
      <StickyContainer className={styles.buttonContainer}>
        <button className={styles.button} onClick={nextButtonHandler}>
          Continue
        </button>
      </StickyContainer>
    </div>
  );
};
